import { Box, Button, Divider, Link, Modal, Stack, TableCell, Tooltip, Typography } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import Table from '@mui/material/Table';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TableBody from '@mui/material/TableBody';
import { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { styled } from '@mui/material/styles';
import InsertChartOutlinedTwoToneIcon from '@mui/icons-material/InsertChartOutlinedTwoTone';
import { createStyles, withStyles } from '@mui/styles';
import { GrUnorderedList } from 'react-icons/gr';
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from 'react-icons/md';
import { useSnackbar } from 'notistack';
import { Cron } from 'react-js-cron';
import 'react-js-cron/dist/styles.css';

import { getDataProcessor, getNodeStatus, runDataProcessorApi, scheduleWorkflow } from "../api's/DataProcessorApi";
import { fetchExecutionListApi } from "../api's/ExecutionApi";
import { getWorkflowById } from "../api's/WorkflowApi";
import convertToRequiredFormat from '../components/react-flow/JsonConverter';
import RunModal from '../components/ruleEngine/RunModal';
import { AuthContext } from '../context/AuthProvider';
import { WorkflowContext } from '../contexts/WorkflowProvider';
import { DateConverter, DateTimeConverter } from '../utils/DateConverter';
import BasicMenu from './BasicMenu';
import BlueChip from './BlueChip';
import FileDialog from './FileDialog';
import GreenChip from './GreenChip';
import InputField from './InputField';
import LoadingIcon from './LoadingIcon';
import RedChip from './RedChip';
import YellowChip from './YellowChip';
import { HighlightMatch } from '../utils/HighLightSearchedKeyword';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: '#eee',
  color: '#000 !important',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

export default function AccordionTable({ fetchTableData, data, search, toggleFavorite, favoriteWorkflows }) {
  const { userId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { setWorkflow } = useContext(WorkflowContext);
  const userPermissions = JSON.parse(sessionStorage.getItem('userPermissions') || '[]');
  const hasExecutePermission = userPermissions.includes('EXECUTE_WORKFLOWS');

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      background: 'none !important',
      color: '#8798AD',
      padding: '8px',
      textTransform: 'uppercase',
      fontSize: 12,
      fontWeight: 600,
      textAlign: 'center',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      padding: '10px',
      textAlign: 'center',
    },
  }));

  const StyledTableRow = withStyles((theme) =>
    createStyles({
      root: {
        border: '1px solid white',
        background: '#FFFFFF',
        boxShadow: '0px 2px 6px #0000000A',
        borderRadius: '5px !important',
      },
    })
  )(TableRow);

  Row.propTypes = {
    row: PropTypes.shape({
      workflow_name: PropTypes.string.isRequired,
      process_type: PropTypes.string.isRequired,
      engagement_name: PropTypes.string.isRequired,
      client_name: PropTypes.string.isRequired,
      created_by: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired,
      execution_mode: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      executionInfoDto: PropTypes.arrayOf(
        PropTypes.shape({
          workflow_type: PropTypes.string.isRequired,
          execution_engine: PropTypes.string.isRequired,
          last_executed_on: PropTypes.string.isRequired,
          execution_status: PropTypes.string.isRequired,
          executed_by: PropTypes.string.isRequired,
          created_by: PropTypes.string.isRequired,
          scheduled_on: PropTypes.string.isRequired,
        })
      ).isRequired,
    }).isRequired,
  };

  function Row(props) {
    const { enqueueSnackbar } = useSnackbar();
    const { row, toggleFavorite, favoriteWorkflows } = props;
    const [openData, setOpenData] = useState(false);
    const [executionInfo, setExecutionInfo] = useState([]);
    const [isLoadingExecution, setIsLoadingExecution] = useState(false);
    const [value, setValue] = useState('30 5 5 4 1,6');
    const [open, setOpen] = React.useState(false);
    const [openRuleEngineModal, setOpenRuleEngineModal] = React.useState(false);

    const [isFileDialogOpen, setIsFileDialogOpen] = useState(false);

    const handleOpenFileDialog = () => {
      setIsFileDialogOpen(true);
    };
    const handleCloseFileDialog = () => {
      setIsFileDialogOpen(false);
    };
    const handleCloseRuleEngineModal = () => {
      setOpenRuleEngineModal(false);
    };
    const handleClose = (value) => {
      setOpen(false);
    };

    const pad2 = (n) => {
      return n < 10 ? `0${n}` : n;
    };

    // const type =
    //   row?.process_type === 'asset360'
    //     ? 'asset360'
    //     : row?.process_type === 'customer360'
    //       ? 'customer360'
    //       : row?.process_type === 'company360'
    //         ? 'company360'
    //         : row?.process_type === 'generic'
    //           ? 'generic'
    //           : 'data';

    // const process_type = row.process_type.replace(/\s+/g, '');

    const handleViewLogs = (workflow_type) => {
      const process_type = row.process_type.toLowerCase().replace(/\s+/g, '');
      const process_workflow_type = row.process_workflow_type.toLowerCase().replace(/\s+/g, '-');

      // console.log(`/workflow-${process_type}-${process_workflow_type}/onboarding?processType=${row.process_type}`);
      navigate(
        `/workflow-${process_type}-${process_workflow_type}/logs/data-processor?processType=${row.process_type}`,
        {
          state: {
            workflow_id: row.workflow_id,
            workflow_name: row.workflow_name,
            client_name: row.client_name,
            engagement_name: row.engagement_name,
            // execution_mode: row.execution_mode,
            created_by: row.created_by,
            created_at: row.created_at,
            status: row.status,
            workflow_type,
            cloudEnvironment: row.cloudEnvironment,
          },
        }
      );
    };

    const runDataProcessorWorkflow = async () => {
      setLoading(true);

      const data = {
        workflow_id: row.workflow_id,
      };

      try {
        await runDataProcessorApi(data);
        enqueueSnackbar('Workflow Running!', {
          variant: 'success',
          autoHideDuration: 3000,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
        });
      } catch (error) {
        if (error.response.status === 403) {
          enqueueSnackbar('You have only Read Permission !!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        } else if (error.response.status === 500) {
          enqueueSnackbar(error.response.data || 'Internal Server Error', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      } finally {
        setLoading(false);
      }
    };

    const handleScheduleWorkflow = async (e) => {
      // setLoading(true);
      try {
        const result = await getDataProcessor(row.workflow_id, row.execution_mode);
        const fetchedWorkflow = await getWorkflowById(row.workflow_id);
        const workflowData = fetchedWorkflow.data;
        const dataProcessorJson = convertToRequiredFormat(result.data.form_data, '', row.workflow_id, '');
        const matchAndMerge = dataProcessorJson.steps.some((item) => item.method_name === 'MatchAndMerge')
          ? dataProcessorJson.steps.filter((item) => item.method_name === 'MatchAndMerge')
          : dataProcessorJson;

        const updatedDataProcessorJson = {
          name: '',
          transformer_execution_details: {},
          spark_config: {},
          udf: {},
          steps: matchAndMerge,
        };

        if (result.status === 200 && updatedDataProcessorJson) {
          let trackingId = '';
          const date = new Date();
          trackingId = `${date.getFullYear().toString()}${pad2(date.getMonth() + 1).toString()}${pad2(
            date.getDate()
          )}${pad2(date.getHours())}${pad2(date.getMinutes())}${pad2(date.getSeconds())}${pad2(
            date.getMilliseconds()
          )}`;

          const batch_table_id = `${workflowData.engagement.client.client_name}_${
            workflowData.engagement.engagement_name
          }_${workflowData.workflow_name}_${
            workflowData.workflow_type === 'Rule Engine' ? 'ruleEngine' : 'dataProcessor'
          }_${trackingId}`;

          const dataprocessorData = {
            client_id: workflowData.engagement.client.client_id,
            engagement_id: workflowData.engagement.engagement_id,
            engagement_name: workflowData.engagement.engagement_name,
            workflow_id: workflowData.workflow_id,
            workflow_name: workflowData.workflow_name,
            dataProcessorJson: dataProcessorJson.steps.some((item) => item.method_name === 'MatchAndMerge')
              ? updatedDataProcessorJson
              : dataProcessorJson,
            ui_time: trackingId,
            execution_id: batch_table_id.replaceAll(' ', ''),
            cloudEnvironment: workflowData.cloudEnvironment,
          };

          await scheduleWorkflow(dataprocessorData, value, userId);

          // if (response.status === 200) {
          enqueueSnackbar('Workflow Scheduled!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
          // }
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 403) {
          enqueueSnackbar('You have only Read Permission !!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        } else {
          enqueueSnackbar('Internal Server Error!', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      }
      // setLoading(false);
    };

    const navigateToWorkflow = async (row) => {
      sessionStorage.removeItem('allNodes');
      sessionStorage.removeItem('node');
      sessionStorage.removeItem('elementCount');
      sessionStorage.removeItem('saved_node');
      sessionStorage.removeItem('edges');
      setLoading(true);
      const response = await getWorkflowById(row.workflow_id);
      setWorkflow(response.data);
      let result, nodeStatus;
      try {
        result = await getDataProcessor(row.workflow_id, row.execution_mode);
        nodeStatus = await getNodeStatus(
          response.data.engagement.client.client_name,
          response.data.engagement.engagement_name,
          response.data.workflow_name,
          response.data.cloudEnvironment
        );
        sessionStorage.setItem('nodeStatus', JSON.stringify(nodeStatus.data));
      } catch (error) {
        console.log(error);
        sessionStorage.setItem('nodeStatus', JSON.stringify([]));
      }
      if (response.status === 200) {
        if (result) {
          let elemCount = 0;

          const newSavedElement = [];

          result.data.nodes.forEach((el) => {
            el['nodeId'] = `${el.nodeId}`;
            elemCount++;
            newSavedElement.push(el.id);
          });

          sessionStorage.setItem('allNodes', JSON.stringify(result.data.form_data));
          sessionStorage.setItem('elementCount', elemCount);
          sessionStorage.setItem('node', JSON.stringify(result.data.nodes));
          sessionStorage.setItem('edges', JSON.stringify(result.data.edges));
          sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
        }
        const process_type = response.data.process_type.toLowerCase().replace(/\s+/g, '');
        const workflow_type = response.data.process_workflow_type.toLowerCase().replace(/\s+/g, '-');
        const path_url = `/workflow-${process_type}-${workflow_type}/onboarding?processType=${response.data.process_type}`;
        const stateObj = {
          workflow_name: row.workflow_name,
          client_name: row.client_name,
          engagement_name: row.engagement_name,
          // execution_mode: row.execution_mode,
          created_by: row.created_by,
          created_at: row.created_at,
          status: row.status,
          workflow_data: response.data,
        };
        navigate(path_url, {
          state: stateObj,
        });
        sessionStorage.setItem('prev_path', JSON.stringify(location.pathname));
        // sessionStorage.setItem('state_obj', JSON.stringify(stateObj));
      }
      setLoading(false);
    };

    const handleRefreshWorkflow = async () => {
      try {
        const response = await fetchExecutionListApi(row.workflow_id);
        if (response.status === 200) {
          setExecutionInfo(response.data);
          enqueueSnackbar('Status Refreshed!', {
            variant: 'success',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 500) {
          enqueueSnackbar('Internal Server Error', {
            variant: 'error',
            autoHideDuration: 3000,
            anchorOrigin: { vertical: 'top', horizontal: 'right' },
          });
        }
      }
    };

    const handleToggleExpand = async () => {
      if (!openData) {
        setIsLoadingExecution(true);
        try {
          const response = await fetchExecutionListApi(row.workflow_id);
          if (response.status === 200) {
            setExecutionInfo(response.data);
          }
        } catch (error) {
          console.error('Error fetching execution data:', error);
        } finally {
          setIsLoadingExecution(false);
        }
      }
      setOpenData(!openData);
    };

    return (
      <>
        <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <StyledTableCell>
            <IconButton aria-label="expand row" size="small" onClick={handleToggleExpand}>
              {openData ? <MdKeyboardArrowDown size={15} /> : <MdKeyboardArrowRight size={15} />}
            </IconButton>
          </StyledTableCell>
          <StyledTableCell>
            {row.status === 'approved' ? (
              <Link
                component="button"
                variant="body2"
                onClick={() => {
                  navigateToWorkflow(row);
                }}
              >
                {HighlightMatch(row.workflow_name, search)}
                {favoriteWorkflows.includes(row.workflow_id)}
              </Link>
            ) : (
              row.workflow_name
            )}
          </StyledTableCell>
          <StyledTableCell>{row.process_type}</StyledTableCell>
          <StyledTableCell>{row.engagement_name}</StyledTableCell>
          <StyledTableCell>{row.client_name}</StyledTableCell>
          {/* <StyledTableCell>{row.execution_mode}</StyledTableCell> */}
          <StyledTableCell>{row.created_by}</StyledTableCell>
          <StyledTableCell>
            {row.updated_at ? DateTimeConverter(row.updated_at) : DateTimeConverter(row.created_at)}
          </StyledTableCell>
          <StyledTableCell>
            {row.status === 'approved' ? (
              <GreenChip title="Approved" />
            ) : row.status === 'pending' ? (
              <YellowChip title="Pending" />
            ) : (
              <RedChip title="Rejected" />
            )}
          </StyledTableCell>
          <StyledTableCell>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <IconButton
                color="primary"
                onClick={() => runDataProcessorWorkflow(row.workflow_id)}
                title="Run Workflow"
                disabled={!hasExecutePermission}
              >
                <PlayArrowIcon />
              </IconButton>

              <BasicMenu
                row={row}
                fetchData={fetchTableData}
                type="Workflow"
                handleRefreshWorkflow={handleRefreshWorkflow}
                toggleFavorite={toggleFavorite}
                favoriteWorkflows={favoriteWorkflows}
              />
            </Box>
          </StyledTableCell>
        </StyledTableRow>
        <StyledTableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
          <StyledTableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={openData} timeout="auto" unmountOnExit>
              {executionInfo.length === 0 ? (
                <Typography
                  variant="h5"
                  component="h5"
                  gutterBottom
                  display="flex"
                  alignContent="center"
                  justifyContent="center"
                  fontWeight={600}
                >
                  No data to display
                </Typography>
              ) : (
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>WORKFLOW TYPE</StyledTableCell>
                      <StyledTableCell>EXECUTION ENGINE</StyledTableCell>
                      <StyledTableCell align="left">LAST EXECUTED ON</StyledTableCell>
                      <StyledTableCell align="left">EXECUTION STATUS</StyledTableCell>
                      <StyledTableCell align="left">EXECUTED BY</StyledTableCell>
                      <StyledTableCell align="left">CREATED BY</StyledTableCell>
                      <StyledTableCell align="left">SCHEDULED FOR</StyledTableCell>
                      {/* <StyledTableCell align="left">ACTION</StyledTableCell> */}
                      <StyledTableCell align="left">LOGS</StyledTableCell>
                      <StyledTableCell align="left">BI</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {executionInfo.map((historyRow) => (
                      <StyledTableRow key={historyRow.workflow_id}>
                        <StyledTableCell>{historyRow.workflow_type}</StyledTableCell>
                        {row.cloudEnvironment === 'SNOWFLAKE' && (
                          <StyledTableCell>{'snowflake' || '--'}</StyledTableCell>
                        )}
                        {row.cloudEnvironment === 'AZURE' && <StyledTableCell>{'data bricks' || '--'}</StyledTableCell>}
                        {row.cloudEnvironment === 'AWS' && <StyledTableCell>{'emr' || '--'}</StyledTableCell>}
                        <StyledTableCell>
                          {(historyRow.last_executed_on && DateConverter(historyRow.last_executed_on)) || '--'}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <Stack direction="row" spacing={1}>
                              {historyRow.execution_status.toLowerCase() === 'completed' ? (
                                <GreenChip title="Completed" />
                              ) : historyRow.execution_status.toLowerCase() === 'saved' ? (
                                <BlueChip title="Saved" />
                              ) : historyRow.execution_status.toLowerCase() === 'running' ? (
                                <YellowChip title="Running" />
                              ) : (
                                <RedChip title="Failed" />
                              )}
                              <Tooltip title="Refresh Status">
                                <RefreshIcon
                                  onClick={handleRefreshWorkflow}
                                  fontSize="small"
                                  style={{ cursor: 'pointer', paddingTop: '3px' }}
                                />
                              </Tooltip>
                            </Stack>
                          </Box>
                        </StyledTableCell>

                        <StyledTableCell align="left">{historyRow.executed_by || '--'}</StyledTableCell>
                        <StyledTableCell align="left">{historyRow.created_by}</StyledTableCell>
                        <StyledTableCell align="left">{historyRow.scheduled_on || '--'}</StyledTableCell>

                        <StyledTableCell>
                          <Tooltip title="Logs">
                            <Button
                              sx={{
                                backgroundColor: 'white',
                                border: 1,
                                borderColor: 'black',
                                maxWidth: '40px',
                                maxHeight: '28px',
                                minWidth: '40px',
                                minHeight: '28px',
                              }}
                              onClick={() => handleViewLogs(historyRow.workflow_type)}
                            >
                              <GrUnorderedList size={20} color="black" />
                            </Button>
                          </Tooltip>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Tooltip title="Business Intelligence">
                            <InsertChartOutlinedTwoToneIcon
                              style={{ display: 'flex', alignItems: 'center' }}
                              fontSize="large"
                              onClick={handleOpenFileDialog}
                            />
                          </Tooltip>
                        </StyledTableCell>
                        {isFileDialogOpen && (
                          <FileDialog
                            isFileDialogOpen={isFileDialogOpen}
                            handleCloseFileDialog={handleCloseFileDialog}
                            workflow={row}
                          />
                        )}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>
        {isLoadingExecution && <LoadingIcon />}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ zIndex: '1' }}
        >
          <Box sx={style}>
            <Typography variant="h6" gutterBottom>
              Schedule Workflow
            </Typography>
            <InputField label="Cron Expression" value={value} onChange={(e) => setValue(e.target.value)} />
            <Divider>OR</Divider>
            <Cron
              value={value}
              setValue={setValue}
              className="my-project-cron my-project-cron-select-dropdown my-project-cron-select my-project-cron-select-dropdown-week-days"
            />

            <Button
              size="small"
              type="submit"
              variant="contained"
              sx={{
                marginTop: '7px',
                marginRight: '7px',
                backgroundColor: '#00043C',
                '&:hover': { backgroundColor: '#00043C' },
              }}
              onClick={handleScheduleWorkflow}
            >
              Save & Submit
            </Button>
          </Box>
        </Modal>

        <RunModal
          workflowId={row.workflow_id}
          openRuleEngineModal={openRuleEngineModal}
          handleCloseRuleEngineModal={handleCloseRuleEngineModal}
        />
      </>
    );
  }

  return (
    <>
      <TableContainer>
        <Table
          aria-label="collapsible table"
          style={{ minWidth: 650, borderSpacing: '0px 4px', borderCollapse: 'separate' }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell> </StyledTableCell>
              <StyledTableCell>Workflow Name</StyledTableCell>
              <StyledTableCell>Process Type</StyledTableCell>
              <StyledTableCell>ENGAGEMENT NAME</StyledTableCell>
              <StyledTableCell>CLIENT NAME</StyledTableCell>
              {/* <StyledTableCell>EXECUTION MODE</StyledTableCell> */}
              <StyledTableCell>CREATED BY</StyledTableCell>
              <StyledTableCell>LAST UPDATED AT</StyledTableCell>
              <StyledTableCell>STATUS</StyledTableCell>
              <StyledTableCell>ACTION</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row) => (
              <Row
                key={row.workflow_id}
                row={row}
                toggleFavorite={toggleFavorite}
                favoriteWorkflows={favoriteWorkflows}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <LoadingIcon />}
    </>
  );
}
